import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Conditional className merger (shadcn style). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
